import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const heroStyle = {
  background: "#f2f2f2",
  color: "#000000",
  padding: "6rem 1rem",
};

const CTA = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/get-started");
  };

  return (
    <section
      style={heroStyle}
      className="text-center d-flex align-items-center justify-content-center"
    >
      <div className="container">
        {/* Small icon / accent */}
        <div className="mb-4">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "50px",
              height: "50px",
              borderRadius: "999px",
              border: "1px solid rgba(0,0,0,0.25)",
              fontSize: "1.5rem",
              color: "#000",
            }}
          >
            ✨
          </span>
        </div>

        {/* Main heading */}
        <h1
          className="fw-bold mb-3"
          style={{
            fontSize: "clamp(2.6rem, 4.8vw, 3.4rem)",
            letterSpacing: "-0.04em",
            color: "#000",
          }}
        >
          You&apos;re About to Build a System
          <br className="d-none d-md-block" />
          That Wins
        </h1>

        {/* Subheading */}
        <p
          className="mb-4 mx-auto"
          style={{
            maxWidth: "540px",
            fontSize: "1.5rem",
            color: "#333",
            lineHeight: 1.8,
          }}
        >
          Their disorganization is your opportunity—your system wins every time.
        </p>

        {/* CTA button with heartbeat animation */}
        <button
          type="button"
          onClick={handleClick}          
          className="btn fw-semibold shadow-sm heartbeat-btn"
          style={{
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "999px",
          }}
        >
          Book Your Free Demo Call
        </button>
      </div>

      <style>{`
        @keyframes heartbeat {
          0% { transform: scale(1); }
          15% { transform: scale(1.08); }
          30% { transform: scale(1); }
          45% { transform: scale(1.08); }
          60% { transform: scale(1); }
          100% { transform: scale(1); }
        }

        .heartbeat-btn {
          padding: 1rem 3.4rem;
          font-size: clamp(1.05rem, 2.6vw, 1.25rem);
          min-width: clamp(230px, 45vw, 280px);
          animation: heartbeat 1.8s ease-in-out infinite;
        }

        .heartbeat-btn:hover {
          animation: none;
          transform: scale(1.05);
        }

        @media (max-width: 576px) {
          .heartbeat-btn {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default CTA;
